// Generated by Melange

import LayoutModuleCss from "./layout.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Shared__Container from "./container.jsx";
import * as Shared__Footer from "./footer.jsx";
import * as Shared__NowPlaying from "./nowPlaying.jsx";
import * as Shared__PlaybackPosition from "./playbackPosition.jsx";
import * as Shared__PlayerToolbar from "./playerToolbar.jsx";
import * as Shared__Queue from "./queue.jsx";
import * as Shared__QueueContext from "./queueContext.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = LayoutModuleCss;

function Layout(Props) {
  const queueTriggerRef = React.useRef(undefined);
  const queueId = React.useId();
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(Shared__QueueContext.Provider.make, {
      children: [
        JsxRuntime.jsx("header", {
          children: JsxRuntime.jsx(Shared__NowPlaying.make, {}),
          className: css.header
        }),
        JsxRuntime.jsx("main", {
          children: JsxRuntime.jsx(ReactRouter.Outlet, {})
        }),
        JsxRuntime.jsx(Shared__Footer.make, {}),
        JsxRuntime.jsxs(Shared__Container.make, {
          children: [
            JsxRuntime.jsx(Shared__PlaybackPosition.make, {}),
            JsxRuntime.jsx(Shared__PlayerToolbar.make, {
              queueId: queueId,
              queueTriggerRef: queueTriggerRef
            })
          ],
          className: css.playerControls
        }),
        JsxRuntime.jsx(Shared__QueueContext.Consumer.make, {
          children: (function (param) {
            return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Shared__Queue.make, {
                id: queueId,
                triggerRef: queueTriggerRef
              }),
              className: css.queue,
              hidden: !param.isOpen
            });
          })
        })
      ]
    }),
    className: css.root
  });
}

const make = Layout;

export {
  make,
}
/* css Not a pure module */
